module.exports = __webpack_public_path__ + "assets/img/10.10f5a11d.jpg";